import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "draggable",
  "use": "draggable-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 64 64\" id=\"draggable\">\n  <path d=\"M8 8h7v7H8zM8 22h7v7H8zM8 35h7v7H8zM8 49h7v7H8zM22 8h7v7h-7zM22 22h7v7h-7zM22 35h7v7h-7zM22 49h7v7h-7zM35 8h7v7h-7zM35 22h7v7h-7zM35 35h7v7h-7zM35 49h7v7h-7zM49 8h7v7h-7zM49 22h7v7h-7zM49 35h7v7h-7zM49 49h7v7h-7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol